import { Session } from "./Session";

export function App() {
  const match = window.location.pathname.match(/^\/c\/([A-Za-z0-9]+)\/?$/);
  if (match) {
    return <Session otp={match[1]} />;
  }
  return (
    <main style={{ fontFamily: "system-ui", maxWidth: 480, margin: "3rem auto", padding: "0 1rem", color: "#222" }}>
      <h1>BKL check-in</h1>
      <p>Tap your link in WhatsApp to start a check-in.</p>
    </main>
  );
}
